import { history } from './../myhistory';
import { combineReducers, Reducer } from 'redux';
import localforage from 'localforage';
import { persistReducer } from "redux-persist";

import FilterReducer from './FilterReducer';
import UserReducer from './UserReducer';
import ManageUsersReducer from './ManageUsersReducer';
import SpendingReportReducer from './SpendingReportReducer';
import EmployeeReportReducer from './EmployeeReportReducer';
import NewEmployeeReportReducer from './NewEmployeeReportReducer';
import EarlyCareerReportReducer from './EarlyCareerReportReducer';
import VendorReportReducer from './VendorReportReducer';
import VendorReportReducer2025 from './VendorReportReducer2025';
import CTSAReportReducer from './CTSAReportReducer';
import SubmissionReducer from './SubmissionReducer';
import MemberReducer from './MemberReducer';
import FactSheetReducer from './FactSheetReducer';
import DetailedDistrictReportReducer from './DetailedDistrictReportReducer';
import AllReportsSharedReducer from './AllReportsSharedReducer';
import { connectRouter } from 'connected-react-router';

import { FilterState, UserState, ManageUsersState, SpendingReportState } from '../interface/MyInterfaces';
import { EmployeeReportState } from '../interface/EmployeeReportInterface';
import { NewEmployeeReportState } from '../interface/NewEmployeeReportInterface';
import { EarlyCareerReportState } from '../interface/EarlyCareerReportInterface';
import { VendorReportState } from '../interface/VendorReportInterface';
import { VendorReportState2025 } from '../interface/VendorReportInterface2025';
import { SubmissionState } from '../interface/SubmissionInterface';
import { MemberState } from '../interface/MemberInterface';
import { CTSAReportState } from '../interface/CTSAReportInterface';
import { FactSheetState } from '../interface/FactSheetInterface';

// The top-level state object
export interface ApplicationState {
    filterProperties: FilterState,
    userProperties: UserState,
    manageUsersProperties: ManageUsersState,
    spendingReportProperties: SpendingReportState,
    employeeReportProperties: EmployeeReportState,
    newEmployeeReportProperties: NewEmployeeReportState,
    earlyCareerReportProperties: EarlyCareerReportState,
    vendorReportProperties: VendorReportState,
    vendorReportProperties2025: VendorReportState2025,
    submissionProperties: SubmissionState,
    memberProperties: MemberState,
    CTSAReportProperties: CTSAReportState,
    factSheetProperties: FactSheetState
}

const allReducers: any = combineReducers({
    filterProperties: FilterReducer,
    userProperties: UserReducer,
    manageUsersProperties: ManageUsersReducer,
    spendingReportProperties: SpendingReportReducer,
    employeeReportProperties: EmployeeReportReducer,
    newEmployeeReportProperties: NewEmployeeReportReducer,
    earlyCareerReportProperties: EarlyCareerReportReducer,
    vendorReportProperties: VendorReportReducer,
    vendorReportProperties2025: VendorReportReducer2025,
    CTSAReportProperties: CTSAReportReducer,
    submissionProperties: SubmissionReducer,
    factSheetProperties: FactSheetReducer,
    memberProperties: MemberReducer,
    detailedDistrictReportProperties: DetailedDistrictReportReducer,
    allReportsSharedProperties: AllReportsSharedReducer,
    router: connectRouter(history)
    //routing: routerReducer,
});

export const persistConfig = {
    key: 'root',
    storage: localforage
}

export default persistReducer(persistConfig, allReducers);